module.exports = __webpack_public_path__ + "img/avatar4.913c9aa8.jpg";